import { matchPath, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { useIsWebviewMode } from 'src/Hooks'

const ROUTES_WITH_LANDSCAPE_ORIENTATION = ['/dashboard/ai360/:installationId/:storageId/details']

type DataReturnType = {
  isContentHeaderHidden: boolean
  isNavigationHidden: boolean
}

/**
 * Custom hook to determine if content header and navigation should be hidden based on the current route in a the mobile app.
 * This is used to optimize the view for routes that are designed for landscape orientation, which are typically should display big charts.
 */
export const useContentView = (): DataReturnType => {
  const isWebView = useIsWebviewMode()
  const location = useLocation()
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))

  const [isContentHeaderHidden, setIsContentHeaderHidden] = useState(false)
  const [isNavigationHidden, setIsNavigationHidden] = useState(false)

  useEffect(() => {
    if (isWebView || !upMd) {
      const currentPath = location.pathname
      const shouldHide = ROUTES_WITH_LANDSCAPE_ORIENTATION.some(routePattern => matchPath(routePattern, currentPath))
      setIsContentHeaderHidden(shouldHide)
      setIsNavigationHidden(shouldHide)
    } else {
      setIsContentHeaderHidden(false)
      setIsNavigationHidden(false)
    }
  }, [location.pathname, isWebView, upMd])

  return { isContentHeaderHidden, isNavigationHidden }
}
